// extracted by mini-css-extract-plugin
export default {"img":"OffCanvas_img__CLqSQ","p":"OffCanvas_p__7ThG0","bg":"OffCanvas_bg__FGbs8","link":"OffCanvas_link__i6kLd","collapse-link":"OffCanvas_collapse-link__rF4fi"};